import React from "react";
import { useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import toast from "react-hot-toast";
import { useAuth } from "../../hooks/useAuth";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import DashProfile from "../../components/DashProfile";
import {
  getDetailsOfUser,
  getRequestDetails,
} from "../../services/userService";
import { addDonationHistory } from "../../services/adminService";

const AddDonationQr = () => {
  const routeParams = useParams();

  const reqid = routeParams.reqid;
  const userid = routeParams.userid;
  const [amountOfBlood, setAmountOfBlood] = useState(0);
  const [userData, setUserData] = useState("");
  const [requestData, setRequestData] = useState("");

  const auth = useAuth();
  const axiosPrivate = useAxiosPrivate();

  useEffect(() => {
    getDetailsOfUser(axiosPrivate, userid, auth?.auth?.token)
      .then((data) => {
        setUserData(data);
        console.log(data);
      })
      .catch((error) => {
        console.error("Error fetching donor data:", error);
      });

    getRequestDetails(axiosPrivate, reqid, auth?.auth?.token)
      .then((data) => {
        setRequestData(data);
        console.log(data);
      })
      .catch((error) => {
        console.error("Error fetching request details:", error);
      });
  }, [auth, axiosPrivate, reqid, userid]);

  const handleAddDonationHistory = () => {
    const donationData = {
      amount_Donated: amountOfBlood,
      request_id: reqid,
      donor_id: userid,
    };

    addDonationHistory(axiosPrivate, donationData, auth?.auth?.token)
      .then((response) => {
        toast.success("Donation Added!");
      })
      .catch((error) => {
        toast.error("Error");
        console.log(error);
      });
  };

  return (
    <div className="p-5 lg:p-16 h-full font-pop">
      <div className="flex flex-col space-y-3">
        <h1 className="font-bold text-lg">Donor ID: {userid}</h1>
        <h1 className="font-bold text-lg">Request ID: {reqid}</h1>
        <h1 className="font-bold text-lg">
          Request Type: {requestData?.donationType}
        </h1>
        <h1 className="font-bold text-lg">
          Request Blood Group: {requestData?.bldGrpRequired}
        </h1>

        <h1 className="font-bold text-lg">Donation amount:(in units)</h1>
        <input
          type="number"
          id="default-input"
          className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
          onChange={(e) => setAmountOfBlood(e.target.value)}
        ></input>

        <button
          onClick={handleAddDonationHistory}
          className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
        >
          Confirm Donation
        </button>
      </div>
      <div className="mt-5">
        <h1 className="text-3xl font-bold ">User Info</h1>
        <h1 className="text-xl">
          Last Donated: {userData?.lastDonationDate || "Never"}
        </h1>
        <DashProfile
          firstName={userData?.firstName}
          lastName={userData?.lastName}
          email={userData?.email}
          phoneNum={userData?.phonenum}
          sex={userData?.sex}
          dob={userData?.dob}
        />
      </div>
    </div>
  );
};

export default AddDonationQr;
